<template>
  <div>
    <div class="container">
      <div class="site-media">
        <div class="media-embed">
          <iframe
            width="560"
            height="315"
            :src="item.section_value.embed_text"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    ...mapGetters(['currentUrl']),
  },
}
</script>

<style lang="scss" scoped>
</style>